import { createTheme } from '@material-ui/core/styles';

const palette = {
  primary: {
    lighter: '#dbeaff',
    light: '#809fff',
    main: '#003fff',
    dark: '#0033cc',
    darker: '#002699',
    contrastText: '#fff',
    background: '#fafafafa'
  },
  secondary: {
    light: '#8b8b90',
    main: '#303031',
    contrastText: '#fff',
  },
  accent: {
    light: '#f0f0f5',
    main: '#e6e7ee',
  },
};

const typography = {
  fontFamily: ['Be Vietnam Pro'],
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  allVariants: true,
  h3: {
    'fontWeight': 900,
    'fontSize': '1.75em',
  },
  h4: {
    'fontSize': '1.5em',
  },
  h6: {
    'fontWeight': 'bold',
  },
  caption: {
    'fontWeight': 'light',
  },
  button: {
    textTransform: 'none',
  },
};

export const gradient =
  'linear-gradient(118deg, ' +
  `${palette.primary.darker} -2.2%, ` +
  `${palette.primary.dark} 22.6%, ` +
  `${palette.primary.main} 55.6%, ` +
  `${palette.primary.light} 86.5%)`;

export default createTheme({
  palette,
  typography,
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '1em',
      },
    },
  },
  shape: {
    borderRadius: 0,
  },
});
